import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeInit } from "@flowbite-react-init";
import { Header, Footer, ErrorBoundary } from "@/components/shared";
import { initSentry } from "@/lib/Sentry";
import { initUserback } from "@/lib/Userback";
import "@/index.css";

initSentry();

const queryClient = new QueryClient();

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  React.useEffect(() => {
    void initUserback();
  }, []);

  return (
    <ErrorBoundary>
      <ThemeInit />
      <QueryClientProvider client={queryClient}>
        <div className="flex flex-col min-h-screen">
          <Header />
          <main className="flex-grow">{children}</main>
          <Footer />
        </div>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export { Layout };
